import { Avatar, AvatarSize, AvatarStyle } from "@beydesign/storybook"
import { ReceivedChatMessage } from "@livekit/components-react"
import { Box, Typography } from "@mui/material"
import dayjs from "dayjs"
import React from "react"
import { useAppContext } from "../../app/Context"
import { Colors } from "../../constants/colors"
import { decodeMessage } from "../../utils/func"

interface ChatBoxProps {
  item: ReceivedChatMessage
}

export function ChatBox({ item }: ChatBoxProps) {
  const context = useAppContext()
  const isMessageFromAgent = item?.from.isAgent
  const name = isMessageFromAgent
    ? context.agent?.name || "Agent"
    : context.user?.name || "User"
  const messageContent = decodeMessage(item?.message) || "No message"

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      gap={1}
      data-testid="chat-message-item"
      data-sender-type={isMessageFromAgent ? "agent" : "user"}
    >
      <Box display={"flex"} alignItems={"flex-start"}>
        <Avatar
          text={name}
          size={AvatarSize.md}
          style={{
            backgroundColor: isMessageFromAgent ? "#F5EFFF" : "#F5F5F7",
          }}
          avatarStyle={AvatarStyle.Letters}
        />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography
            fontSize={{ xs: "0.75rem", sm: "0.875rem" }}
            variant="body1"
            color={Colors.Purple}
            fontWeight={600}
            data-testid="chat-message-sender"
          >
            {name}
          </Typography>
          <Typography
            variant="body1"
            fontSize={{ xs: "0.625rem", sm: "0.75rem" }}
            color="gray"
            data-testid="chat-message-timestamp"
          >
            {dayjs(item.timestamp).format("h:mm A")}
          </Typography>
        </Box>
        <Box
          data-testid={`chat-message-bubble-${isMessageFromAgent ? "agent" : "user"}`}
          sx={{
            backgroundColor: isMessageFromAgent ? "#F5EFFF" : "#F5F5F7",
            padding: "0.5rem",
            borderRadius: "1rem",
            borderTopLeftRadius: "0.25rem",
            borderTopRightRadius: "1rem",
            width: "fit-content",
            marginRight: "0.5rem",
            position: "relative",
          }}
        >
          <Typography
            variant="body1"
            color={Colors.Purple}
            fontSize={{ xs: "0.8rem", sm: "1rem" }}
            sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
            data-testid={
              isMessageFromAgent
                ? "chat-message-text"
                : "chat-message-text-user"
            }
            data-message-content={messageContent}
          >
            {messageContent}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
